import axios from 'axios';

const getBaseURL = (): string => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // In dev (port 3000), point to backend on 8080. In production (nginx), use relative /api
  const { protocol, hostname, port } = window.location;
  if (port === '3000') {
    return `${protocol}//${hostname}:8080/api`;
  }
  return '/api';
};

const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const errorData = error.response.data;
      const isSessionReplaced = errorData?.error === 'SESSION_REPLACED';

      localStorage.removeItem('token');
      localStorage.removeItem('user');

      if (isSessionReplaced) {
        // Store the message so the login page can show it
        localStorage.setItem('session_replaced', '1');
      }

      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
